import I18n from 'I18n';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TableRow } from 'foundations-components/transitional/components/Table';
import { Flex } from 'foundations-components/components/Flex';
import { InlineEditInput } from './InlineEditInput';
import { StyledTableCell } from '../table/StyledTableCell';
import { useMilestoneTableSize } from '../table/MilestoneTableSizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CreateMilestoneRow({
  onSubmit,
  onCancel
}) {
  const size = useMilestoneTableSize();
  const content = /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: false,
      disabled: true,
      size: "sm",
      marginBlockStart: "100"
    }), /*#__PURE__*/_jsx(InlineEditInput, {
      onSubmit: onSubmit,
      onCancel: onCancel,
      placeholder: I18n.text('dealPlan.milestones.inputPlaceholder'),
      dataTestId: "create-milestone-input"
    })]
  });
  if (size === 'small') {
    return /*#__PURE__*/_jsx(TableRow, {
      children: /*#__PURE__*/_jsx(StyledTableCell, {
        colSpan: 3,
        children: content
      })
    });
  }
  return /*#__PURE__*/_jsxs(TableRow, {
    children: [/*#__PURE__*/_jsx(StyledTableCell, {
      children: content
    }), /*#__PURE__*/_jsx(StyledTableCell, {}), /*#__PURE__*/_jsx(StyledTableCell, {}), /*#__PURE__*/_jsx(StyledTableCell, {})]
  });
}